<template>
  <div class="person_card_center">
    <el-row class="person_card_wrap" type="flex" justify="space-between">
      <el-col class="card_item" :span="11" :xs="24" v-for="(item, index) in personList" :key="index"
        :style="{ background: `url(${item.Image}) 50% 50% no-repeat`, backgroundSize: 'cover' }">
        <h2>{{ item.Title }}</h2>
        <p>{{ item.SubTitle && item.SubTitle[0] }}</p>
        <div class="card_bg">
        </div>
        <div class="card_desc">{{ item.SubTitle && item.SubTitle[1] }}</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    personList: {
      type: Array,
      default: [],
    },
  },
}
</script>

<style lang="scss" scoped>
.person_card_center {
  width: 70%;
  margin: 50px auto;

  @media screen and (max-width: 768px) {
    width: 90%;
  }

  .person_card_wrap {
    @media screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: space-between;
    }

    .card_item {
      color: #fff;
      height: 400px;
      padding: 30px;

      &:nth-child(2) {

        @media screen and (max-width: 768px) {
          margin-top: 1rem;
        }
      }

      h2 {
        font-size: 30px;

        @media screen and (max-width: 768px) {
          font-size: 24px;
        }
      }

      p {
        font-size: 18px;

        @media screen and (max-width: 768px) {
          font-size: 13px;
          padding: 10px 0;
        }
      }

      @media screen and (max-width: 768px) {
        height: auto;
        padding: 20px;
        background-size: cover;
        color: #fff;
      }

      .card_bg {
        width: 35px;
        height: 5px;
        margin-top: 10px;
        background: #fff;

        @media screen and (max-width: 768px) {
          width: 20px;
          height: 3px;
        }
      }

      .card_desc {
        color: rgb(211, 211, 211);
        width: 60%;
        margin-top: 20px;
        line-height: 1.5rem;
        font-size: 16px;

        @media screen and (max-width: 768px) {
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
}
</style>